import { render, staticRenderFns } from "./RefundManagement.vue?vue&type=template&id=4058cb06&scoped=true"
import script from "./RefundManagement.vue?vue&type=script&lang=js"
export * from "./RefundManagement.vue?vue&type=script&lang=js"
import style0 from "./RefundManagement.vue?vue&type=style&index=0&id=4058cb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058cb06",
  null
  
)

export default component.exports